<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row" ref="counts">
	<div
      class="vx-col w-full xl:w-2/12 lg:w-3/12  mb-base expo-das-left"        
      >
        <vx-card class="exhi_left_box_wrap">
          <div class="vx-col  flex items-center mx-auto one">
			  <div class="infocolor-box-left flex-grow py-3">
				<h2>{{ExhibitorStatsVal.registrations}}</h2>
				<h3>Total Attendees</h3>
			  </div>
			  <div class="infocolor-box-right"> &nbsp; </div>
          </div>
		  <!---Total Attendees less 45% -->
		   <div class="vx-col  mb-0 flex items-center mx-auto less_30_perc " style="display:none !important">
			<div class="infocolor-box-right four px-0 text-center" style="width:30%">{{ ExhibitorStatsVal.registrations | getPercent(ExhibitorStatsVal.registrations)}}%</div>
			  <div class="infocolor-box-left flex-grow py-3 ml-3 ">
				<h2>{{ExhibitorStatsVal.registrations}}</h2>
				<h3>Total Attendees</h3>
			  </div>
			  
          </div>
		  <!--Total Attendees less 45%---->
          <div class="vx-col flex items-center mx-auto two">
		  
			  <div class="infocolor-box-left flex-grow py-3">
				<h2>{{ExhibitorStatsVal.views.count}}</h2>
				<h3>Viewed</h3>
			  </div>
			  <div class="infocolor-box-right">{{ ExhibitorStatsVal.views.percent }}%</div>
          </div>
		  <!---Views less 45%--->
		   <div class="vx-col  mb-0 flex items-center mx-auto less_30_perc " style="display:none !important">
			<div class="infocolor-box-right four px-0 text-center" style="width:30%">{{ ExhibitorStatsVal.views.percent}}%</div>
			  <div class="infocolor-box-left flex-grow py-3 ml-3 ">
				<h2>{{ExhibitorStatsVal.views.count}}</h2>
				<h3>Viewed</h3>
			  </div>
			  
          </div>
		  <!--Views less 45%---->
          <div class="vx-col flex items-center mx-auto three" style="width:65%">
			  <div class="infocolor-box-left flex-grow py-3">
				<h2>{{ExhibitorStatsVal.engagements.count}}</h2>
				<h3>Engaged</h3>
			  </div>
			 <div class="infocolor-box-right">{{ExhibitorStatsVal.engagements.percent}}%</div>
          </div>
		  <!---Engaged less 45%--->
		   <div class="vx-col  mb-0 flex items-center mx-auto less_30_perc " style="display:none !important">
			<div class="infocolor-box-right four px-0 text-center" style="width:30%">{{ExhibitorStatsVal.engagements.percent}}%</div>
			  <div class="infocolor-box-left flex-grow py-3 ml-3 ">
				<h2>{{ExhibitorStatsVal.engagements.count}}</h2>
				<h3>Engaged</h3>
			  </div>
			  
          </div>
		  <!--Engaged less 45%---->
		  <!-- Video Meetings start-->
          <div class="vx-col  mb-0 flex items-center mx-auto four" style="display:none !important">
			  <div class="infocolor-box-left flex-grow py-3">
				<h2>{{ExhibitorStatsVal.videoCalls.count}}</h2>
				<h3>Video Meetings</h3>
			  </div>
			  <div class="infocolor-box-right">{{ExhibitorStatsVal.videoCalls.percent}}%</div>
          </div>
		  <!-- Video Meetings end-->
		  <!---Video Meetings less 45%-->
		   <div class="vx-col  mb-0 flex items-center mx-auto less_30_perc " >
			<div class="infocolor-box-right four px-0 text-center" style="width:30%">{{ExhibitorStatsVal.videoCalls.percent}}%</div>
			  <div class="infocolor-box-left flex-grow py-3 ml-3 ">
				<h2>{{ExhibitorStatsVal.videoCalls.count}}</h2>
				<h3>Video Meetings</h3>
			  </div>
			  
          </div>
		  <!--Video Meetings less 45%---->
        </vx-card>
      </div>
      <!-- CARD 1: CONGRATS -->
      <div
        class="vx-col w-full xl:w-9/12 lg:w-9/12  mb-base expo-das-right"
        
      >
        <vx-card title="Exhibitor Statistics">
          <div slot="no-body" v-if="totBoothVisits">
            <vue-apex-charts
              class="mb-5"
              height="300"
              type="bar"              
              :series="[{'name':'Total Count','data':[totBoothVisits,totResourceViews,totVideoViews,totProfileViews,totRepVideoCalls,totRoundtableVisits,totBusinessCardExchanges,totChatMessages,totMeetingsCreated]}]"
              :options="chartOptions"
            />
          </div>
          <div
            slot="no-body"
            style="text-align: center; v-align:center;"
            v-else
          >
            <span>No Data available</span>
          </div>
        </vx-card>
      </div>
      
      <div class="vx-col xl:w-1/1 lg:w-1/1 w-full mb-base">
        <vx-card title="Booth Engagement By Views">
          <vs-tabs>
            <vs-tab
              label="Exhibitor"
              icon-pack="feather"
              icon="icon-cpu"
            >
              <vs-button
                @click='$router.push("/report/businessCard")'
                style="float: right"
                class="shadow-md lg:mt-0 mouse-pointer mr-10"
                color="primary"
                type="border"
                >Business Card Exchanges
              </vs-button>
              <vs-button
                style="float: right"
                icon-pack="feather"
                icon="icon-chevrons-right"
                color="primary"
                type="border"
                icon-after
                class="shadow-md lg:mt-0 mouse-pointer mr-2"
                @click='$router.push("/event/exhibitors")'
                >Booth List</vs-button
              >
              <div class="flex">
                <span class="flex items-center"
                  ><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div>
                  <span>Click</span></span
                >
                <span class="flex items-center ml-4"
                  ><div
                    class="h-3 w-3 rounded-full mr-1"
                    style="color: #008080; background: #008080"
                  ></div>
                  <span>Business Card Exchange</span></span
                >
              </div>
              <vue-apex-charts
                type="bar"
                height="277"
                :options="exhibitorPageViewOptions"
                :series="exhibitorPageViewDetails"
              />
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import analyticsData from "../ui-elements/card/analyticsData.js";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChartjsComponentBarChart from "../charts-and-maps/charts/chartjs/charts-components/ChartjsComponentBarChart.vue";
// Store Module
import moduleDashboardManagement from "@/store/dashboard/moduleDashboard.js";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import ls from "@/common/localStorage";

export default {
  data() {
    return {
      totBoothVisits: 0,
      totResourceViews: 0,
      totVideoViews: 0,
      totProfileViews: 0,
      totRepVideoCalls: 0,
      totRoundtableVisits: 0,
      totBusinessCardExchanges: 0,
      totChatMessages: 0,
      totMeetingsCreated: 0,
      chartOptions: { "labels": ['Total Booth  Visits', 'Total Resource Views', 'Total Video Views', 'Total Profile Views', 'Total Rep Video Calls', 'Total Roundtable Visits', 'Total Business Card Exchanges', 'Total Chat Messages', 'Total Meetings Created'], "chart": { "type": "bar", "legend": { "show": true }, "toolbar": { "show": true } }, "stroke": { "width": 0 }, "colors": ["#7961F9", "#FF9F43", "#EA5455", "#ea54d3", "#54eaea", "#54ea86"], "plotOptions": { "bar": { "horizontal": false, "dataLabels": { "enabled": true }, "endingShape": "rounded", "columnWidth": "100%", "barHeight": '100%', } },
      },
      /*chartOptions: { "grid": { "borderColor": "#ebebeb", "padding": { "left": 0, "right": 0 } }, "legend": { "show": true }, "dataLabels": { "enabled": true }, "chart": { "stacked": true, "type": "bar", "toolbar": { "show": true } }, "colors": ["#4c8af6", "#EA5455"], "plotOptions": { "bar": { "columnWidth": "10%" } }, "xaxis": { "labels": { "style": { "cssClass": "text-grey fill-current" } }, "axisTicks": { "show": false }, "categories": ['Tot Booth Visits', 'Tot Resource Views', 'Tot Video Views', 'Tot Profile Views', 'Tot Rep Video Calls', 'Tot Roundtable Visits', 'Tot Business Card Exchanges', 'Tot Chat Messages', 'Tot Meetings Created'], "axisBorder": { "show": false }, "convertedCatToNumeric": false }, "yaxis": {
                        "tickAmount": 5, "labels": {
                            "style": { "cssClass": "text-grey fill-current" }, "formatter": function (val) {
                                return val.toFixed(0);
                            }
                        }
                    }, "tooltip": { "x": { "show": false } }
      },*/
      pageViewOptions: {},
      pageViewDetails: [],
      exhibitorPageViewOptions: {},
      exhibitorPageViewDetails: [],
      ExhibitorStatsVal: {
        registrations: 0,
        views: 0,
        engagements: 0,
        videoCalls: 0
      }
    };
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChartjsComponentBarChart,
  },
  filters: {
    getPercent(val, totVal){
      if(!val || !totVal)
        return 0;
      let numberTotVal = Number(totVal);
      let numberVal = Number(val);
      let percentVal = (numberVal / numberTotVal) * 100;
      return Math.ceil(percentVal);
    }
  },
  methods: {
    onScroll() {
    },
    getEventStats() {
      this.$store
        .dispatch("dashboardManagement/getEventStats")
        .then((res) => {
          this.totBoothVisits = res.totBoothVisits;
          this.totResourceViews = res.totResourceViews;
          this.totVideoViews = res.totVideoViews;
          this.totProfileViews = res.totProfileViews;
          this.totRepVideoCalls = res.totRepVideoCalls;
          this.totRoundtableVisits = res.totRoundtableVisits;
          this.totBusinessCardExchanges = res.totBusinessCardExchanges;
          this.totChatMessages = res.totChatMessages;
          this.totMeetingsCreated = res.totMeetingsCreated;          
        })
        .catch((err) => {
          console.error(err);
        });
    },
    fetchPageEngagementUrl() {
      this.$store
        .dispatch("dashboardManagement/fetchEngagementUrlDetails")
        .then((res) => {
          this.pageViewOptions = res.data[0].options;
          this.pageViewDetails = res.data1;
          this.exhibitorPageViewOptions = res.data3[0].options;
          this.exhibitorPageViewDetails = res.data2;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getExhibitorStats(){
      this.$store
        .dispatch("dashboardManagement/getExhibitorStats", 365)
        .then((res) => {
          this.ExhibitorStatsVal = res;
        })
        .catch((err) => {
          console.error(err);
        });
    }

  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("scroll", this.onScroll);
      this.onScroll(); // needed for initial loading on page
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  created() {
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    if (!moduleDashboardManagement.isRegistered) {
      this.$store.registerModule(
        "dashboardManagement",
        moduleDashboardManagement
      );
      moduleDashboardManagement.isRegistered = true;      
    }
    this.getEventStats();
    this.getExhibitorStats();
    this.fetchPageEngagementUrl();
  },
};
</script>
